import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
const CARDS = [{
  titulo: 'Detenernos',
  texto: 'Hay momentos en la vida en los que necesitamos parar. No para alejarnos de nuestra realidad, sino para mirarla desde otro lugar y respirar más despacio.'
}, {
  titulo: 'Escucharnos',
  texto: 'Cuatro noches en Akalki, sobre la Laguna de los Siete Colores, y una última noche en Cancún. Un encuentro mixto donde cada persona vive su proceso a su propio ritmo.'
}, {
  titulo: 'Volver más ligeros',
  texto: 'Agradecer el camino recorrido, reconocer aquello que ya es momento de soltar y regresar más conscientes y más conectados con nuestra esencia.'
}];
export function Isla() {
  return <section id="bacalar" className="w-full px-5 py-24 sm:px-8 sm:py-32" data-id="element-204" data-mp="36w8opd01ri89">
      <div className="mx-auto max-w-7xl" data-id="element-205" data-mp="36yleudfykywe">
        <SectionHeading eyebrow="Una invitación a volver a nosotros" title="Bacalar: naturaleza, presencia, conexión y renovación" subtitle="No venimos a escapar de nuestra vida. Venimos a detenernos, escucharnos y recordar quiénes somos." data-id="element-206" data-mp="31y75ms2mfiws" />

        <div className="mt-16 grid gap-6 md:grid-cols-3" data-id="element-207" data-mp="1ux6bq191saae">
          {CARDS.map((card, i) => <Reveal key={card.titulo} delay={i * 0.1} data-id="element-208" data-mp="1zvrd4401d00f" data-mpi={i}>
              <article className="h-full rounded-3xl border bg-white/60 p-8 backdrop-blur-sm transition-transform hover:-translate-y-1" style={{
            borderColor: 'rgba(200,153,46,0.25)'
          }} data-id="element-209" data-mp="1zvhoajqq8ywb">
                <span className="font-heading text-5xl font-light" style={{
              color: 'rgba(200,153,46,0.5)'
            }} data-id="element-210" data-mp="1c65htrmsb4xp">
                  0{i + 1}
                </span>
                <h3 className="mt-5 font-heading text-xl font-normal" style={{
              color: 'var(--ink)'
            }} data-id="element-211" data-mp="jfx54fb0pcqi">
                  {card.titulo}
                </h3>
                <p className="mt-3 text-sm leading-relaxed" style={{
              color: 'rgba(42,36,32,0.72)'
            }} data-id="element-212" data-mp="cdi7058097t4">
                  {card.texto}
                </p>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}